import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UseModalProps,
} from "@chakra-ui/modal";
import { ThemingProps } from "@chakra-ui/react";
import React, { useRef } from "react";
import { MemberFilterQueryForm } from "../../forms/MemberFilterQueryForm";

interface MemberFilterQueryModalProps {
  isOpen: boolean;
  memberQueryFilter: string;
  businessId: string;
  onSuccess: (query?: string, segmentName?: string, segmentId?: string) => void;
  onClose: () => void;
  segmentMode?: boolean;
  segmentId?: string | null;
  excludeNotificationScheduleId?: string | null;
}

export const MemberFilterQueryModal = ({
  isOpen,
  memberQueryFilter,
  businessId,
  onSuccess,
  onClose,
  segmentMode,
  segmentId,
  excludeNotificationScheduleId,
  ...modalProps
}: MemberFilterQueryModalProps & UseModalProps & ThemingProps<"Modal">) => {
  const initialFocusRef = useRef<HTMLInputElement>(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      initialFocusRef={initialFocusRef}
      {...modalProps}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {segmentMode
            ? segmentId
              ? "Edit Segment"
              : "Create Segment"
            : "Member Filter Query"}
        </ModalHeader>
        <ModalBody>
          <MemberFilterQueryForm
            businessId={businessId}
            query={memberQueryFilter}
            onSuccess={onSuccess}
            onCancel={onClose}
            segmentMode={segmentMode}
            segmentId={segmentId}
            excludeNotificationScheduleId={excludeNotificationScheduleId}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
